import { makeStyles } from '@mui/styles/'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1.5rem',
    width: '100vw',
    maxWidth: '100%',
    minHeight: 'calc(100vh - 110px)',
  },

  locker: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2.25rem',
    height: '2.25rem',
    fontSize: '1.5rem',
    color: Colors.gray,
    border: `solid 2px ${Colors.gray}`,
    borderRadius: '50%',
  },

  titleContainer: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
  },

  title: {
    color: 'black',
    fontSize: '2rem',
    fontWeight: '700',
    marginBottom: '1rem',
    maxWidth: '100vw',
  },

  subTitle: {
    fonSize: "1.4 rem",
    fontWeight: '500',
    marginBottom: '1rem',
    padding: '0 2rem',
  },

  instructions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 500,
    maxWidth: '80vw',
    margin: '1rem auto',
    fontSize: '1.25rem',

    '& > div':
      {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        gap: '0.25rem',
        textAlign: 'left',
        width: 'fit-content',
      },

    '& div > ul':
      {
        listStyle: 'none',
        paddingLeft: 0,
      },

    '& div > ul > li':
      {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        justifyContent: 'flex-start',
        padding: '0.15rem 0.25rem',
        fontSize: '1.25rem',
      }
    ,
  },

  success: {
    color: Colors.green,
    fontSize: '2rem',
  },

  waiting: {
    color: Colors.pastelRed,
    fontSize: '2rem',
  },

  titleBar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
  },

  sent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '50%',
  },

  formBox: {
    width: 400,
    maxWidth: '80%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    alignItems: 'center',
    '& button': {
      marginTop: '1rem',
    },
  },
}))

export default styles
